import Box from "@mui/material/Box";
import LanguageContext from "components/LanguageContext";
import SubTemplateWrapper from "components/LayoutFront/SubTemplateWrapper";
import Block from "components/templatesComponents/Block";
import Button from "components/templatesComponents/Button";
import Link from "components/templatesComponents/Link";
import ResultList from "components/templatesComponents/ResultList";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const HomeResults = (props) => {
  const { page = {} } = props;
  const { title, contents } = page;
  const { dynamicPart } = contents;

  const { language } = useContext(LanguageContext);

  const displayResults =
    Array.isArray(dynamicPart) &&
    dynamicPart
      .filter((el) => el.props?.children?.type === ResultList)
      ?.find((list) => list.props?.children?.props?.results?.length > 0);

  return (
    <SubTemplateWrapper title={title}>
      {displayResults && <Box sx={{ bgcolor: "primary.10", mt: 1, mb: 3 }}>{displayResults}</Box>}
      <Box sx={{ textAlign: "center" }}>
        <Block>
          <Button
            secondaryColor
            component={Link}
            basic
            page={page}
            aria-label={t[language].home_results.button_aria_label}
          >
            {t[language].home_results.button_label}
          </Button>
        </Block>
      </Box>
    </SubTemplateWrapper>
  );
};

HomeResults.propTypes = {
  page: PropTypes.shape(),
};

export default HomeResults;
